
export default {
    getCookie(name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            // return unescape(arr[2]);
            return arr[2];
        } else {
            return null;
        }
    },
    setCookie(cookieName,cookieValue){
        var d = new Date();
        d.setHours(d.getHours()+cookieDates);
        var cookieDates = "expires=" + d.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + "; " + 12+"; path=/"
    }
    // setCookie(cname, cvalue, exdays) {
    //     //cname 名字
    //     //cvalue 值
    //     //exdays 时间            0.01大概25分钟
    //     var d = new Date();
    //     d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    //     var expires = "expires=" + d.toUTCString();
    //     document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/"   //这个很重要代表在那个层级下可以访问cookie
    // }

}


// WEBPACK FOOTER //
// ./src/common/common.js